module.exports = "<div> <flat-button type=flat :light-wave=false class=waves-red>flat button</flat-button> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/buttons/flat-button.vue
 ** module id = 150
 ** module chunks = 0
 **/